module.exports = __webpack_public_path__ + "assets/img/sandbox-en.c22792e2.png";